export const DEFAULT_MAX_API_KEYS = 10;
export const DEFAULT_MAX_CREDENTIAL_CIDR_COUNT = 10;
